import React from 'react';

const renderDesc = (desc: string) =>
  desc.split('\n').map((line, idx) => (
    <span key={idx}>
      {line}
      {idx < desc.split('\n').length - 1 && <br />}
    </span>
  ));

const EventDetailsSection = ({ t }: any) => {
  const prices = t?.eventDetails?.prices || {
    label: 'Entry Fee',
    '5k': '-',
    '10k': '-',
    kids: '-'
  };
  return (
    <section id="race-info" className="race-info-section">
      <h2>{t.raceInfo}</h2>
      <div className="race-types">
        <div className="race-type">
          <span className="race-icon">🏃‍♂️</span>
          <h3>5K</h3>
          <p>{renderDesc(t.race5kDesc)}</p>
        </div>
        <div className="race-type">
          <span className="race-icon">🏃‍♀️</span>
          <h3>10K</h3>
          <p>{renderDesc(t.race10kDesc)}</p>
        </div>
        <div className="race-type">
          <span className="race-icon">👦</span>
          <h3>{t.reg.raceKids}</h3>
          <p>{renderDesc(t.raceKidsDesc)}</p>
        </div>
      </div>
      <div className="race-types"><div className="race-type">Трката на 5 км е за рекреативци и доколку се пријават професионален атлетичар нема да биде прогласен. Времиња под 19 минути за мажи и 21 минута за жени не се признаваат.<br/>
Трката на 10 км е за рекреативци и професионални атлетичари.</div></div>
      {/* <a href="#full-race-details" className="btn tertiary">{t.seeFullRace}</a> */}
    </section>
  );
};

export default EventDetailsSection;
